import { SortOrder } from '@constants/common.constants';
import { IPaginatedFetchRequest } from '@common-actions/paginatedFetch.types';

/** API response list key for GET userHistoricalDocuments. */
export const HISTORICAL_DOCUMENTS_LIST_KEY = 'userHistoricalDocuments';

/** Sort fields for GET userHistoricalDocuments (member or CAP). */
export const HISTORICAL_DOCUMENTS_SORT_FIELDS = {
    DOCUMENT_DESCRIPTION: 'DOCUMENT_DESCRIPTION',
    UPLOADED_DATE: 'UPLOADED_DATE',
} as const;

export type HistoricalDocumentsSortField =
    (typeof HISTORICAL_DOCUMENTS_SORT_FIELDS)[keyof typeof HISTORICAL_DOCUMENTS_SORT_FIELDS];

export interface IHistoricalDocument {
    id: number;
    documentDescription: string;
    documentUrl: string | null;
    uploadedBy: string;
    uploadedDate: string;
    status: string;
}

export interface IHistoricalDocumentsPageData {
    userHistoricalDocuments: IHistoricalDocument[];
    totalElements: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
}

export interface IHistoricalDocumentsListState {
    hasLoaded: boolean;
    documents: IHistoricalDocument[];
    totalCount: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
    sortColumn: HistoricalDocumentsSortField;
    sortOrder: SortOrder;
    hasLoadError: boolean;
}

export interface IHistoricalDocumentsFetchRequest extends IPaginatedFetchRequest {
    sortColumn: HistoricalDocumentsSortField;
}
